import { render, staticRenderFns } from "./FooterAdditionalLinks.vue?vue&type=template&id=3f6fa861&scoped=true&"
import script from "./FooterAdditionalLinks.vue?vue&type=script&lang=js&"
export * from "./FooterAdditionalLinks.vue?vue&type=script&lang=js&"
import style0 from "./FooterAdditionalLinks.vue?vue&type=style&index=0&id=3f6fa861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6fa861",
  null
  
)

/* custom blocks */
import block0 from "@/locales/footer_additional_links.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2FFooter%2FFooterAdditionalLinks.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports